<template>
  <div class="AddrSelect" style="display: inline-block">
    <!--            国-->
    <el-select size="mini" v-model="country" :placeholder="$t('please.select.country.or.region').toString()"
      @change="countryChange(country)">
      <el-option value=""/>
      <el-option v-for="role in countryList" :key="role.country" :label="role.country"
      :value="role.country"/>
    </el-select>
    <!--            省-->
    <el-select size="mini" v-loading="doLoading" v-model="province" :placeholder="$t('please.select.province').toString()"
      @change="provinceChange(province)">
      <el-option value=""/>
      <el-option v-for="role in provinceList" :key="role.id" :label="role.province"
      :value="role.id"/>
    </el-select>
  </div>
</template>

<script>

import {getRecAddrs} from "@/api/member";

export default {
  name: "AddrSelect",
  data() {
    return {
      doLoading: false,
      country: '',
      province: '',
      countryList: [],
      provinceList: [],
    }
  },
  props: {
    AddrInfo: {
      type: Array,
      default() {
        return []
      }
    },
  },
  watch: {
    async AddrInfo(val) {
      // console.log(JSON.parse(JSON.stringify(val)), 'AddrSelect中接收的值')
      if (val.length === 2) {
        this.country = val[1].country
        this.doLoading = true
        this.provinceList = await this.getRecAddrByCountry(val[1].country)
        this.province = val[0].id
        this.doLoading = false
      }
    }
  },
  async created() {
    this.countryList = await this.getRecAddrByCountry()
  },
  async mounted() {
  },
  methods: {
    getRecAddrByCountry(country) {
      return new Promise((resolve, reject) => {
        getRecAddrs({'country': country}).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    async countryChange(country) {
      this.doLoading = true
      this.provinceList = await this.getRecAddrByCountry(country)
      this.province = ''
      this.$emit("provinceEmit", false);
      this.doLoading = false
    },
    provinceChange(province) {
      let res = this.provinceList.filter(item=>item.id===province)[0]
      // console.log(JSON.parse(JSON.stringify(res)), 'AddrSelect中发送的值')
      this.$emit("provinceEmit", res);
    },
  }

}
</script>

<style scoped lang="scss">

</style>